"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nano = exports.googleFont = exports.keyframes = exports.drule = exports.rule = exports.put = exports.reset = void 0;
const tslib_1 = require("tslib");
const nano_css_1 = require("nano-css");
const cache_1 = require("nano-css/addon/cache");
const stable_1 = require("nano-css/addon/stable");
const nesting_1 = require("nano-css/addon/nesting");
const atoms_1 = require("nano-css/addon/atoms");
const rule_1 = require("nano-css/addon/rule");
const drule_1 = require("nano-css/addon/drule");
const keyframes_1 = require("nano-css/addon/keyframes");
const Normalize_1 = require("nano-css/addon/reset/Normalize");
const reset_font_1 = require("nano-css/addon/reset-font");
const googleFont_1 = require("nano-css/addon/googleFont");
tslib_1.__exportStar(require("nano-css"), exports);
const nano = (0, nano_css_1.create)({
    pfx: 'nano-css',
});
exports.nano = nano;
(0, cache_1.addon)(nano);
(0, stable_1.addon)(nano);
(0, nesting_1.addon)(nano);
(0, atoms_1.addon)(nano);
(0, rule_1.addon)(nano);
(0, drule_1.addon)(nano);
(0, keyframes_1.addon)(nano);
(0, googleFont_1.addon)(nano);
const reset = () => {
    (0, Normalize_1.addon)(nano);
    (0, reset_font_1.addon)(nano);
};
exports.reset = reset;
exports.put = nano.put;
exports.rule = nano.rule;
exports.drule = nano.drule;
exports.keyframes = nano.keyframes;
exports.googleFont = nano.googleFont;
//# sourceMappingURL=css.js.map